import React, { useEffect, useState } from "react";
import { Grid, Button } from "@material-ui/core";
import Controls from "../../../controls/Controls";
import { useForm, Form } from "../../../controls/useForm";
import { request } from "../../../../api/Service";
import { store } from "../../../../redux-store/store";
import { toast } from "react-toastify";

const returnables = () => [
  { id: "true", title: "true" },
  { id: "false", title: "False" },
];

const initialFValues = {
  productId: "",
  salesPrice: "",
  effectiveDate: "",
};

export default function AddProductForm(props) {
  const { addOrEdit, recordForEdit, productsDropdown } = props;
  const validate = (fieldValues = values) => {
    let temp = { ...errors };

    if ("productId" in fieldValues)
      temp.productId = fieldValues.productId ? "" : "Product Id is Required.";
    if ("salesPrice" in fieldValues)
      temp.salesPrice = fieldValues.salesPrice
        ? ""
        : "Sales Price is Required.";
    if ("effectiveDate" in fieldValues)
      temp.effectiveDate = fieldValues.effectiveDate
        ? ""
        : "Effective Date is Required.";

    setErrors({
      ...temp,
    });
    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  var get_product = (sku) =>
    request("get", {}, `api/Admin/get-product/${sku}`).then((data) => {
      if (data.companyId > 0) {
        toast.success("Product does Exist");
      }
    });

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialFValues, true, validate, get_product);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      var data = { ...values};
      addOrEdit(data, resetForm);
    }
  };

  useEffect(() => {
    if (recordForEdit !== null)
      setValues({
        ...recordForEdit,
      });
  }, [recordForEdit]);

  const [holdBtn, setHoldBtn] = useState(true);

  useEffect(() => {
    // Check if all values are filled
    const allValuesFilled = Object.values(values).every(
      (value) => value !== "" && value !== null && value !== undefined
    );

    // Check if file is selected
    if (allValuesFilled) {
      setHoldBtn(false);
    } else {
      setHoldBtn(true);
    }
  }, [values]);

  return (
    <Form onSubmit={handleSubmit}>
      <Grid container>
        <Grid item xs={6}>
          <Controls.Select
            name="productId"
            label="Select Product"
            value={values.productId || ""}
            onChange={handleInputChange}
            options={productsDropdown}
            error={errors.productId}
          />
        </Grid>
        <Grid item xs={6}>
          <Controls.Input
            name="salesPrice"
            label="Sales Price"
            value={values.salesPrice || ""}
            onChange={handleInputChange}
            error={errors.salesPrice}
          />

          <Controls.Input
            label="Effective Date"
            name="effectiveDate"
            type="date"
            value={values.effectiveDate || ""}
            onChange={handleInputChange}
            error={errors.effectiveDate}
          />

          <div>
            <Controls.Button disabled={holdBtn} type="submit" text="Submit" />
          </div>
        </Grid>
      </Grid>
    </Form>
  );
}
